import { render, staticRenderFns } from "./tree-chart.vue?vue&type=template&id=797e8521&"
import script from "./tree-chart.ts?vue&type=script&lang=ts&"
export * from "./tree-chart.ts?vue&type=script&lang=ts&"
import style0 from "./tree-chart.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports